var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestPassed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18.6179,
    height: 18,
    rx: 5,
    fill: "#E8FCF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18.6179,
    height: 18,
    rx: 5,
    stroke: "#E8FCF3",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42612 12.4L13.546 8.45001L12.6631 7.60001L9.42612 10.7L7.95475 9.30001L7.07193 10.15L9.42612 12.4ZM10.3089 16.4C9.39727 16.4 8.53753 16.2333 7.72972 15.9C6.9219 15.5667 6.21507 15.1083 5.60921 14.525C5.00335 13.9417 4.52732 13.2611 4.18111 12.4833C3.83491 11.7056 3.6618 10.8778 3.6618 10C3.6618 9.11112 3.83491 8.28056 4.18111 7.50834C4.52732 6.73612 5.00335 6.05834 5.60921 5.47501C6.21507 4.89167 6.9219 4.43334 7.72972 4.10001C8.53753 3.76667 9.39727 3.60001 10.3089 3.60001C11.2322 3.60001 12.0948 3.76667 12.8968 4.10001C13.6989 4.43334 14.4028 4.89167 15.0087 5.47501C15.6145 6.05834 16.0906 6.73612 16.4368 7.50834C16.783 8.28056 16.9561 9.11112 16.9561 10C16.9561 10.8778 16.783 11.7056 16.4368 12.4833C16.0906 13.2611 15.6145 13.9417 15.0087 14.525C14.4028 15.1083 13.6989 15.5667 12.8968 15.9C12.0948 16.2333 11.2322 16.4 10.3089 16.4ZM10.3089 15.2C11.8092 15.2 13.0844 14.6945 14.1345 13.6833C15.1847 12.6722 15.7098 11.4445 15.7098 10C15.7098 8.55556 15.1847 7.32778 14.1345 6.31667C13.0844 5.30556 11.8092 4.80001 10.3089 4.80001C8.80872 4.80001 7.53353 5.30556 6.48338 6.31667C5.43322 7.32778 4.90814 8.55556 4.90814 10C4.90814 11.4445 5.43322 12.6722 6.48338 13.6833C7.53353 14.6945 8.80872 15.2 10.3089 15.2Z",
    fill: "#00754E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestPassed);
export default __webpack_public_path__ + "static/media/TestPassed.95863430400eb6d62e61030f04f6fe9d.svg";
export { ForwardRef as ReactComponent };